import request from '@/utils/request';
//用户角色列表
export function getAllRole() {
  return request('/tracking-report/queryAllRole', {
    method: 'POST',
    // data: values,
  });
}
//用户行为列表
export function getTrackingLogList(values) {
  return request('/tracking-report/queryTrackingLogList', {
    method: 'POST',
    data: values,
  });
}
//用户行为明细轨迹
export function getTrackingLogTrajectory(values) {
  return request('/tracking-report/queryTrackingLogTrajectory', {
    method: 'POST',
    data: values,
  });
}
//用户行为明细趋势
export function getTrackingLogTrend(values) {
  return request('/tracking-report/queryTrackingLogTrend', {
    method: 'POST',
    data: values,
  });
}
//用户详情
export function getTrackingUserDetail(values) {
  return request('/tracking-report/queryTrackingLogUser', {
    method: 'POST',
    data: values,
  });
}
//报表数据导出

export function exportTrackingListData(values) {
  return request('/tracking-report/downloadTrackingListData', {
    method: 'POST',
    data: values,
  });
}
